import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { InteractionOutlined } from '@vicons/antd';
//import { PricetagOutline, LocationOutline } from '@vicons/ionicons5';
import { renderIcon } from '@/utils/index';
import { CheckCircleOutlined,RiseOutlined} from '@vicons/antd';


/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 *
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/changeLog',
    name: 'changelog_layout',
    redirect: '/changeLog/index',
    component: Layout,
    meta: {
      title: 'Change Log',
      icon: renderIcon(InteractionOutlined),
      //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
      /*
      permissions: [
        'catalog_item_read',
        'catalog_location_read',
        'catalog_specification_read',
        'catalog_imit_specification_read',
      ],
      */
      sort: 4,
    },
    children: [
      {
        path: 'index',
        name: 'changelog',
        
        meta: {
          title: 'Construction CL',
          prefix: 'Project',
          icon: renderIcon(CheckCircleOutlined),
          historyTable:"construction_change_log",
          spname:"construction_change_log",
          // icon: renderIcon(ApiOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          //permissions: ['equipment_read'],
        },
        component: () => import('@/views/changeLog/view/index.vue'),
      },
   
    {
      path: 'commitmentlog',
      name: 'commitmentlog',
      
      meta: {
        title: 'Commitment CL',
        prefix: '',
        icon: renderIcon(RiseOutlined),
        historyTable:"commitment_change_log",
        spname:"commitment_change_log",
        // icon: renderIcon(ApiOutlined),
        //配置该路由需要哪些权限可访问 这里是针对单个路由
        //permissions: ['equipment_read'],
      },
      component: () => import('@/views/changeLog/view/commitmentLog.vue'),
    },
  ],
  
},
   
    
  
];

export default routes;
